import { COOKIE_MPS_PHONE_KEY, COOKIE_MPS_PHONE_OPTIONS } from '~/shared/const/cookie'

/**
 * Работа с кукой телефона пользователя (COOKIE_MPS_PHONE_KEY).
 * Телефон попадает в куку из query mps_user_phone (middleware digital-lecture-phone)
 * и используется для фиксации просмотра лекции у неавторизованных пользователей.
 */
export function useMpsPhone() {
  const phoneCookie = useCookie<string | null>(COOKIE_MPS_PHONE_KEY, COOKIE_MPS_PHONE_OPTIONS)

  const getMpsPhone = (): string | null => phoneCookie.value ?? null

  const setMpsPhone = (phone: string): void => {
    phoneCookie.value = phone
  }

  return { getMpsPhone, setMpsPhone }
}